import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  CHANNEL_COLORS,
  DEFAULT_COLORS,
  DEFAULT_TEXT_COLOR
} from '../common/aggregation_page_colors';
import ResponsiveImg from '../common/responsive_img';
import { isInternalLink } from '../../utils/link';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import {get, find} from 'lodash';
import { FaIcon } from '../common/fa_icons';

export const RESPONSIVE_IMG_HEIGHT_PX = 150;
export const FIRST_RESPONSIVE_IMG_WIDTH_PX = 700;
export const DEFAULT_RESPONSIVE_IMG_WIDTH_PX = 350;

export class CtaButton extends Component {
  handleClick = () => {
    const type = isInternalLink(this.props.url) ? 'internal' : 'outbound';

    sendDataLayerEvent('Click', {
      module_name: 'CTA Bar',
      cta_text: this.props.label + ' ' + this.props.prompt,
      destination_url: this.props.url,
      position: this.props.indexWithinRow - 1,
      itemName: this.props.label + ' ' + this.props.prompt,
      linkHeadline: this.props.label + ' ' + this.props.prompt,
      linkTitle: this.props.label + ' ' + this.props.prompt,
      linkType: type,
      // linkUID: '', cannot fill out because API always returns null
    });

    sendAnalyticsEvent(
      'CTA Bar',
      'Click',
      `CTA Button ${this.props.indexWithinRow}`
    );
  }


  getButtonStyle = (page_id, index) => {
    const channelColors = find(CHANNEL_COLORS, { 'id': page_id });

    return {
      backgroundColor: get(channelColors, `colors[${index}]`,
        DEFAULT_COLORS[index]),
      color: get(channelColors, 'text_color', DEFAULT_TEXT_COLOR)
    };
  }

  getResponsiveImgWidth = (index) => (index === 1)
    ? FIRST_RESPONSIVE_IMG_WIDTH_PX
    : DEFAULT_RESPONSIVE_IMG_WIDTH_PX;
    /*
     * Note: When not on mobile, dimensions of the first CTA image are set to 700 x 150
     * Ideally, mobile dimensions should be to 350 x 150 to match the other CTA images
     * Now, the dimensions are 700 x 150 on all breakpoints in order to fix the automatic crop with such a wide image
     * However, this image is obviously too big for mobile. Long term, we should have a tool in Dash
     * for editors to crop this more preciscely with the correct dimensions.
     */

  render() {
    const { label, prompt, url, src_full, page_id, indexWithinRow } = this.props;

    const style = this.getButtonStyle(page_id, indexWithinRow - 1);
    const responsiveImgProps = {
      src: src_full,
      height: RESPONSIVE_IMG_HEIGHT_PX,
      width: this.getResponsiveImgWidth(indexWithinRow),
      alt: label || '',

      /*
       * In case an editor uploads an alpha PNG to the CTA bar, we want to
       * respect that, so we have to suppress the logic that converts PNGs to
       * JPGs. Passing in "format: 'alwaysUseSrcExtension'" should accomplish
       * that.
       */
      format: 'alwaysUseSrcExtension'
    };

    return (
      <div onClick={this.handleClick} className="cta-button three-unequal-card" style={style}>
        <a href={url} target="_blank">
          <div className="three-unequal-content-wrapper">
            <div className="cta-content three-unequal-content">
              <div className="cta-image">
                <ResponsiveImg {...responsiveImgProps} />
              </div>
              <div className="three-unequal-content-inner">
                <div className="cta-label">
                  <span dangerouslySetInnerHTML={{ __html: label }} />
                </div>
                <div className="cta-prompt">
                  <span dangerouslySetInnerHTML={{ __html: prompt }} />
                  <FaIcon iconName="angle-right" />
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  }
}

CtaButton.propTypes = {
  label: PropTypes.string.isRequired,
  prompt: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  rowType: PropTypes.string.isRequired,
  src_full: PropTypes.string.isRequired,
  page_id: PropTypes.number.isRequired,
  indexWithinRow: PropTypes.number.isRequired
};

export default CtaButton;
